import { instance as axios } from "@/services/axios";

export default {
  async GetVideoList(form) {
    try {
      var response = await axios.post(`/Video/list`, form);
      return response.data;
    } catch (error) {
      // await IsSwalUnauthorized(error.response)
      return error.response;
    }
  },
  async GetVideoByID(id) {
    try {
      var response = await axios.get(`/Video/${id}`);
      return response.data;
    } catch (error) {
      // await IsSwalUnauthorized(error.response)
      return error.response;
    }
  },
  async GetVideoMainCategory() {
    try {
      var response = await axios.get(`/video/category`);
      return response.data;
    } catch (error) {
      // await IsSwalUnauthorized(error.response)
      return error.response;
    }
  },
  async GetVideoSubCategory(form) {
    try {
      var response = await axios.post(`/video/subcategory`, form);
      return response.data;
    } catch (error) {
      // await IsSwalUnauthorized(error.response)
      return error.response;
    }
  },
  async CreateVideo(form) {
    try {
      var response = await axios.post(`/Video`, form);
      return response.data;
    } catch (error) {
      // await IsSwalUnauthorized(error.response)
      return error.response;
    }
  },
  async UpdateVideo(form) {
    try {
      var response = await axios.put(`/Video/${form.id}`, form);
      return response.data;
    } catch (error) {
      // await IsSwalUnauthorized(error.response)
      return error.response;
    }
  },
  async DeleteVideo(id) {
    try {
      var response = await axios.delete(`/Video/${id}`);
      return response.data;
    } catch (error) {
      // await IsSwalUnauthorized(error.response)
      return error.response;
    }
  },
};
